<section id="retirement-plans">
  <div class="container">
      <div class="row">
          <div class="col-12">
              <h1>Investing for Catholics App <img src="https://services.ifa.com/art/images/3370_50x50_c_free-app.webp" alt="new sticker" /></h1>
          </div>
      </div>
      <div class="row">
        <div class="col-12 font-w">
          
            <a href="https://apps.apple.com/us/app/investing-for-catholics/id6758739546"  alt="Download on the App Store">
              <img src="https://services.ifa.com/art/images/2135_2022-6-14-16-12-40.png" height="50" />
            </a>
          
        </div>
      </div>
      <div class="row">
        <div class="col-12 font-w">
          <i>The IFC app is free to download and provides simplified access to features and content available on our website and elsewhere. Note that downloading this app does not include access to Investing for Catholics advisory services.</i>
        </div>
      </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row m-4">
      Read more about Investing for Catholics' socially responsible investing philosophy. 
      Access IFC's charts, articles, and videos on demand. 
      Use the app to learn about portfolios that align Catholic values with sound financial science.
      Take a no-obligation survey to help you explore different stock-to-bond allocations.
      
    </div>
    <div class="d-flex flex-row justify-content-evenly flex-wrap">
   
      
      <div><img class="mobileScreenshot" src="https://services.ifa.com/art/images/3517_2026-3-17-15-26-43.png" alt="IFC App Screenshot Catholic Values Investing"></div>

      <div><img class="mobileScreenshot" src="https://services.ifa.com/art/images/3517_2026-3-17-15-27-1.png" alt="IFC App Screenshot Survey"></div>

      <div><img class="mobileScreenshot" src="https://services.ifa.com/art/images/3517_2026-3-17-15-27-15.png" alt="IFC App Screenshot Team"></div>

      <div><img class="mobileScreenshot" src="https://services.ifa.com/art/images/3517_2026-3-17-15-27-31.png" alt="IFC App Screenshot Advisor Mary Brunson"></div>

      <div><img class="mobileScreenshot" src="https://services.ifa.com/art/images/3517_2026-3-17-15-27-49.png" alt="IFC App Screenshot Articles"></div>
      


      
      </div>
      <div class="d-flex flex-row justify-content-evenly flex-wrap mt-4">
        <a href="https://apps.apple.com/us/app/investing-for-catholics/id6758739546"  alt="Download on the App Store">
          <img src="https://services.ifa.com/art/images/2135_2022-6-14-16-12-40.png" height="50" alt="Download on the Appstore" />
        </a>
      </div>
    </div>
</section>